<div class="col-xs-12" *ngIf="!showButtonLoader">
    <div class="col-xs-12 no-pad" *ngIf="emiFlag && PaymentResponse"
        [ngClass]="(emiFlag && PaymentResponse && ButtonName !== 'RETRY PAYMENT') ? 'col-sm-6' : 'col-sm-12'">
        <button id="payment_btn" class="btn btn-primary btn-block btnconfirm payment-buttons btn-single fixed bottom-55"
            (click)="showButtonLoader = true;payHorizontal();"
            [disabled]="!emiFlag || ((paymentMode !== 'EMIC' && ButtonName === 'RETRY PAYMENT') || disableFlag) || showButtonLoader">
            {{ButtonName === 'RETRY PAYMENT' ? 'RETRY BY EMI CARD' : 'PAY BY EMI CARD'}} RS.
            {{Amount ? formatter.ToCurrency(Amount.toString()) : ''}}
            <p class="gst-label">( Inclusive of GST )</p>
        </button>
    </div>
    <div class="col-xs-12" *ngIf="ButtonName && PaymentResponse && PaymentObject"
        [ngClass]="(emiFlag && PaymentResponse && ButtonName !== 'RETRY PAYMENT') ? 'col-sm-6' : 'col-sm-12'">
        <button id="payment_btn" class="btn btn-primary btn-block btnconfirm payment-buttons btn-single fixed"
            *ngIf="!payLaterFLow" (click)="showButtonLoader = true;payHorizontal();"
            [disabled]="((paymentMode === 'EMIC' && ButtonName === 'RETRY PAYMENT') || disableFlag || showButtonLoader)">
            {{ButtonName}}
            RS. {{formatter.ToCurrency(PaymentObject.amount.toString())}}
            <p class="gst-label">( Inclusive of GST )</p>
        </button>
        <button id="payment_btn1" class="btn btn-primary btn-block btnconfirm payment-buttons btn-single fixed"
            *ngIf="payLaterFLow " (click)="isPaymentFailed ? payHorizontal() : openPaymentOtpDrawer()"
            [disabled]="((paymentMode === 'EMIC' && ButtonName === 'RETRY PAYMENT') || disableFlag || showButtonLoader)">
            PROCEED
            <!-- {{ButtonName}}
            RS. {{formatter.ToCurrency(PaymentObject.amount.toString())}}
            <p class="gst-label">( Inclusive of GST )</p> -->
        </button>
    </div>
    <div class="text-center">
        <span class="text-danger fontStyle" *ngIf="notEligible">You are not eligible for pay by EMI</span>
    </div>

    <div class="margin10 col-xs-12 col-md-12 top-spc-10 center margin-top10" *ngIf="serviceMessage">
        <div class="col-xs-12 col-md-12 text-center">
            <span class="text-danger fontStyle text-center">{{serviceMessage}}
            </span>
        </div>
    </div>
</div>
<div *ngIf="showButtonLoader" class="pull-center">
    <img class="" src="assets/img/Button-Loader.gif" [hidden]="sharedService.theme === 'dark'" />
    <img class="" src="assets/img/Button-Loader_blue.gif" [hidden]="sharedService.theme !== 'dark'" />
</div>
<div class="text-danger text-center" *ngIf="initiateError">{{initiateError}}
</div>

<!-- OTP drawer -->
<ng-template #otpBody>
    <div class="drawer-info p-3 pt-4 pb-5">
        <div class="col opt-container">
            <div class="pl-1">
                <h4 class="text-bold mt-3 mb-4">OTP Verification</h4>
                <p class="mb-4 sub-txt">
                    Enter 6-digit OTP sent to your mobile number +91 {{ PaymentObject.mobileNumber }} to confirm your
                    application submission
                </p>
            </div>
            <div class="otp-control">
                <fieldset [disabled]="(resendOTPCount > 5 || triggerCount > 5)">
                    <form [formGroup]="healthOtpForm">
                        <div class="digit-group bot-spc-10 center m-t-2">
                            <input id="digit1" #digit1 formControlName="digit1" type="tel"
                                (keypress)="FormValidators.IsNumeric($event)"
                                (keydown)="onKeydown($event, digit1, digit2)" aria-label="otp"
                                (input)="onOTPReceive(digit1,'input',digit2);FormValidators.onInputEntry($event, digit2)"
                                pattern="^[0-9]*$" maxlength="1" (blur)="onOTPReceive(digit1,'blur');"
                                (focus)="onOTPReceive(digit1,'focus');"
                                (keyup)="FormValidators.IsNumberMobile($event,healthOtpForm,'digit1')"
                                (click)="onOTPReceive(digit1,'click');" (paste)="onPaste($event, digit1)" />
                            <input #digit2 formControlName="digit2" type="tel"
                                (keypress)="FormValidators.IsNumeric($event)"
                                (keydown)="onKeydown($event, digit1, digit3)"
                                (input)="FormValidators.onInputEntry($event, digit3)"
                                (keyup)="FormValidators.IsNumberMobile($event,healthOtpForm,'digit2')"
                                pattern="^[0-9]*$" maxlength="1" (paste)="onPaste($event)" />
                            <input #digit3 formControlName="digit3" type="tel"
                                (keypress)="FormValidators.IsNumeric($event)"
                                (keydown)="onKeydown($event, digit2, digit4)"
                                (input)="FormValidators.onInputEntry($event, digit4)"
                                (keyup)="FormValidators.IsNumberMobile($event,healthOtpForm,'digit3')"
                                pattern="^[0-9]*$" maxlength="1" (paste)="onPaste($event)" />
                            <input #digit4 formControlName="digit4" type="tel"
                                (keypress)="FormValidators.IsNumeric($event)"
                                (keydown)="onKeydown($event, digit3, digit5)"
                                (input)="FormValidators.onInputEntry($event, digit5)"
                                (keyup)="FormValidators.IsNumberMobile($event,healthOtpForm,'digit4')"
                                pattern="^[0-9]*$" maxlength="1" (paste)="onPaste($event)" />
                            <input #digit5 formControlName="digit5" type="tel"
                                (keypress)="FormValidators.IsNumeric($event)"
                                (keydown)="onKeydown($event, digit4, digit6)"
                                (input)="FormValidators.onInputEntry($event, digit6)"
                                (keyup)="FormValidators.IsNumberMobile($event,healthOtpForm,'digit5')"
                                pattern="^[0-9]*$" maxlength="1" (paste)="onPaste($event)" />
                            <input #digit6 id="digit6" formControlName="digit6" type="tel"
                                (keypress)="FormValidators.IsNumeric($event)"
                                (keydown)="onKeydown($event, digit5, digit6)"
                                (keyup)="FormValidators.IsNumberMobile($event,healthOtpForm,'digit6')"
                                pattern="^[0-9]*$" maxlength="1" (paste)="onPaste($event)" />
                        </div>
                    </form>
                </fieldset>
                <div class="spc-btwn bot-spc-10">
                    <div class="col-md-3 d-md-flex mt-2">
                        <span>
                            <span id="timer">{{remainingTime}}</span>
                        </span>
                    </div>
                    <div class="col-md-4 bot-spc-10 text-center otpfont text-success " *ngIf="isTimerStarted">OTP sent
                        successfully!</div>
                    <a class="resend-mob-otp-link mb-1" (click)="resendOTP()" href="javascript:void(0);"
                        [ngClass]="{'grey-link':isTimerStarted ||resendOTPCount > 5 || ServiceErrorCode === 'QDM-518'}">Resend
                        OTP?</a>
                </div>
                <div class="row bot-spc-10" *ngIf="ServiceError">
                    <div class="col-xs-12 center mb-1">
                        <span class="text-danger fontStyle" *ngIf="ServiceError">{{ServiceError}}
                        </span>
                    </div>
                </div>
                <div class="row bot-spc-10" *ngIf="resendOTPCount > 5">
                    <div class="col-xs-12 center mb-1">
                        <span class="text-danger fontStyle" *ngIf="resendOTPCount > 5"> You've exhausted all 5 attempts
                            to enter the correct OTP.
                        </span>
                    </div>
                </div>
                <!-- Start Submit Button  -->
                <div class="otp-submit-section">
                    <button class="btn btn-primary btnconfirm btn-single" type="submit" [disabled]="!isOtpFormValid"
                        (click)="validateOtp();">SUBMIT
                    </button>
                </div>
                <!-- End Submit Button -->
                <section *ngIf="newOtpshowLoader">
                    <app-loader></app-loader>
                </section>

            </div>
        </div>
    </div>
</ng-template>

<app-drawer [isModal]='true' [allowBodyScroll]="true" [drawerId]="'paymentOtpDrawer'" [width]="'half'"
    (backdrop)="onBackdropClick($event)">
    <ng-container *ngTemplateOutlet="otpBody"></ng-container>
</app-drawer>
<!-- Non STP drawer -->
<app-drawer [isModal]='true' [drawerId]="'nonstp'" [width]="'half'" [backdropDisable]="true">
    <ng-container *ngTemplateOutlet="nonStpDrawerBody"></ng-container>
</app-drawer>
<ng-template #nonStpDrawerBody>
    <div class="center mt-30">
        <img class="thumb-icon" src="assets/feedback_noted.png">
    </div>
    <div class="bre-msg text-center mb-6">
        <div class="msg-header">We appreciate your honesty!</div>
        <div class="msg-description">
            This plan is for ages 18-40. Tap "OKAY" to find other exclusive plans crafted for you.
        </div>
    </div>
    <div class="divide hide-desktop"></div>
    <div class="btn-block non-stp-block center" id="user-profile-next-btn" *ngIf="!showLoader">
        <div class="col-lg-12 col-md-12 col-xs-12 nonstp-btn text-center">
            <button type=" button" class="btn btnconfirm btn-primary btn-single" (click)="onNonStpClick()">OKAY
            </button>
        </div>
    </div>
</ng-template>
<section *ngIf="PaymentIdReceived || showLoader">
    <app-loader></app-loader>
</section>